import { useState } from "react";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import EnvironmentalSection from "./components/EnvironmentalSection";
import WhyClearioSection from "./components/WhyClearioSection";
import BeeloylSection from "./components/BeeloylSection";
import ReviewsSection from "./components/ReviewsSection";
import BlogSection from "./components/BlogSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";
import QuoteModal from "./components/QuoteModal";

export default function Home() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <main className="font-sans bg-white">
      <Navbar onBookNow={() => setModalOpen(true)} />
      <HeroSection onBookNow={() => setModalOpen(true)} />
      <ServicesSection onBookNow={() => setModalOpen(true)} />
      <EnvironmentalSection />
      <WhyClearioSection />
      <BeeloylSection />
      <ReviewsSection />
      <BlogSection />
      <FAQSection />
      <Footer />
      <QuoteModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />

      {/* Floating Book Now button (mobile) */}
      <div className="fixed bottom-6 right-6 z-40 md:hidden">
        <button
          onClick={() => setModalOpen(true)}
          style={{ touchAction: "manipulation" }}
          className="bg-cl-green text-white font-black px-6 py-4 rounded-full shadow-lg cursor-pointer whitespace-nowrap flex items-center gap-2 active:scale-95 transition-transform"
        >
          <i className="ri-calendar-check-line text-base"></i>
          Book Now
        </button>
      </div>
    </main>
  );
}
